module.exports = __webpack_public_path__ + "static/img/diariobg.965cf50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/TCE-AL/diariobg.jpg
// module id = Jh4b
// module chunks = 1